import './conversion-log-csv-export.component.scss'
import {ConversionLogServiceName} from "../../../../../utils/names/serviceNames";
import {ConversionLogService} from "../../../../service/ConversionLogService";
import {ConversionLogsSelectionOptions} from "../../../../model/ConversionLogsSelectionOptions";

export class ConversionLogCsvExportComponent {
    static instance = {
        template: require('./conversion-log-csv-export.component.html'),
        controller: [
            '$filter',
            ConversionLogServiceName,
            ConversionLogCsvExportComponent
        ],
        controllerAs: '$ctrl',
        bindings: {
            selectionOptions: '<'
        }
    }

    private selectionOptions: ConversionLogsSelectionOptions;
    private readonly FILE_TYPE = 'text/csv';

    constructor(private $filter: ng.IFilterService,
                private conversionLogService: ConversionLogService) {
    }

    exportLogsCSV = () => {
        this.conversionLogService.fetchConversionsLogCsv(this.selectionOptions)
            .then(resp => {
                require("downloadjs")(resp.data, this.generateFileName(), this.FILE_TYPE);
            });
    }

    private generateFileName() {
        let startDate = this.getFormattedDate(this.selectionOptions.filter.startDate);
        let endDate = this.getFormattedDate(this.selectionOptions.filter.endDate);
        return `conversio-log-${startDate}-${endDate}.csv`;
    }

    private getFormattedDate(date): string {
        return this.$filter('date')(date, 'MMM_dd_yyyy');
    }
}